import auroraColorPalette from '../../colors';

const input = {
  root: {
    border: '1px solid rgba(0,0,0,0.32)',
    borderRadius: 8,
    overflow: 'hidden',
    alignItems: 'center',
    transition: 'border 0.3s ease',
  },
  underline: {
    '&:after': {
      height: 'calc(100% + 1px)',
      borderRadius: 8,
      bottom: -1,
      boxShadow: `0 0 1px ${auroraColorPalette.primary.main}`,
    },
    '&:before': {
      display: 'none',
    },
  },
  input: {
    padding: 10,
    fontSize: 14,
  },
  multiline: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 24,
  },
};

export default input;

export const inputAdornment = {
  root: {
    alignItems: 'flex-end',
    paddingLeft: 0,
    paddingRight: 0,
    height: 'auto',
    '& button': {
      width: 32,
      height: 32,
      padding: 0,
    },
    '& p': {
      minWidth: 24,
      lineHeight: '16px',
    },
    '& > svg': {
      position: 'relative',
      top: 3,
    },
  },
  positionStart: {
    marginRight: 0,
    paddingRight: '0 !important',
  },
  positionEnd: {
    marginLeft: 0,
  },
};
